module.exports = __webpack_public_path__ + "static/images/hero.ad6819d18e04ef4d83785c949881fb15.jpg";